import Overview from '@rebuild/materials/shared/question/Overview.vue';
import Full from '@rebuild/materials/shared/question/FullIndex.vue';
import MobFull from '@rebuild/materials/shared/question/mobile/MobFullIndex.vue';
import MobOverview from '@rebuild/materials/shared/question/mobile/MobOverview.vue';
import MobDetail from '@rebuild/materials/shared/question/mobile/MobDetail.vue';

export const componentMap = {
	overview: Overview,
	full: Full,
	'mob-overview': MobOverview,
	'mob-full': MobFull,
	'mob-detail': MobDetail
}; 